var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSymbolBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 14C19.5891 14 16.0001 17.589 16.0001 21.995C15.9711 28.44 23.6961 33.784 24.0001 34C24.0001 34 32.0291 28.44 32.0001 22C32.0001 17.589 28.4111 14 24.0001 14ZM24.0001 26C21.7901 26 20.0001 24.21 20.0001 22C20.0001 19.79 21.7901 18 24.0001 18C26.2101 18 28.0001 19.79 28.0001 22C28.0001 24.21 26.2101 26 24.0001 26Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSymbolBlack);
export default __webpack_public_path__ + "static/media/location-symbol-black.8553da291ec39205f59a61a0f369e24e.svg";
export { ForwardRef as ReactComponent };